import React, { useState } from "react";
import { Stack, styled, Radio, Typography } from "@mui/material";

const Card = styled(Stack)(({ theme }: any) => ({
  // width: "100%",
  // minWidth: "650px",
  minHeight: "150px",
  background: theme.palette.common.white,
  boxShadow: "1px 1px 4px rgba(0, 0, 0, 0.25)"
}));
interface PaymentOptionInterface {
  id: any;
  paymentOption: string;
  fees: number;
  date: string;
}
export interface PaymenyOptionsWidgetInterface {
  list: PaymentOptionInterface[];
  handleAction: (data: any) => void;
}
export interface CellInterface {
  value: any;
  selectedValue: any;
  handleChange: (value: any) => void;
  title: string;
  fees: number;
  date: string;
  border?: boolean;
  id?: any;
}
const Cell = ({
  id,
  value,
  selectedValue,
  handleChange,
  title,
  fees,
  date,
  border
}: CellInterface) => {
  return (
    <Stack
      my={1}
      id={id}
      spacing={2}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      p={"10px 10px 10px 0px"}
      borderBottom={(theme: any) =>
        border ? `1px solid ${theme.palette.common.borderGrey}` : "none"}
    >
      <Radio
        className="font-green"
        color="primary"
        checked={selectedValue === value}
        onChange={() => handleChange(value)}
        value={value}
        name="radio-buttons"
      />
      <Stack textAlign="left" spacing={1} flexGrow={1}>
        <Typography variant="h4">
          {title}
        </Typography>
        <Typography fontSize={16} fontWeight={400}>
          {date}
        </Typography>
      </Stack>
      <Typography fontSize={16} fontWeight={600}>
        {`$${fees}`}
      </Typography>
    </Stack>
  );
};
const PaymenyOptionsWidget = ({
  handleAction,
  list
}: PaymenyOptionsWidgetInterface) => {
  const [selectedValue, setSelectedValue] = useState<any>();
  const handleChange = (val: any) => {
    setSelectedValue(val);
    handleAction(val);
  };
  return (
    <Card padding={2} justifyContent="space-between">
      {list && list.length > 0
        ? list.map((item: PaymentOptionInterface, index) =>
            <Cell
              id={item.id}
              value={item}
              border={index !== list.length - 1}
              title={item.paymentOption}
              fees={item.fees}
              date={item.date}
              handleChange={handleChange}
              selectedValue={selectedValue}
            />
          )
        : <Typography textAlign="center">
            No payment options available
          </Typography>}
    </Card>
  );
};
export default PaymenyOptionsWidget;
